// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MKGMz","closeIcon":"styles_closeIcon__x0BZp","content":"styles_content__o189L"};